





















import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "Triangles",

  props: {
    colorClassLight: {
      required: true,
      type: String,
    },
    colorClassDark: {
      required: true,
      type: String,
    },
  },

  setup(props) {
    return {
      colorClassDark: props.colorClassDark,
      colorClassLight: props.colorClassLight,
    };
  },
});
